// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qLwId","image":"styles_image__dH26I"};